import React, { useCallback, useState } from 'react';
import { CoinsLabel } from '../coinsLabel';
import type { CoinsLabelProps } from '../coinsLabel';
import { Image } from '../../../image';

import {
	ImageWrapper,
	NameLabel,
	RoleLabel,
	DetailsWrapper,
	EmployeeDetailsWrapper,
	EmployeeDetailsCardWrapper,
	EmployeeDetailsCardContent,
	EmployeeDetailsCardAccordion,
} from './EmployeeDetailsCard.style';

import { ConfettiArmedContext } from './confettiArmedContext';

export type EmployeeDetailsCardProps = {
	name: string;
	profilePicture: string;
	role: string;
	coinsLabel?: CoinsLabelProps;
	DetailsText?: string;
	defaultOpen?: boolean;
	scrollable?: boolean;
	children?: React.ReactNode;
};

export const EmployeeDetailsCard = ({
	name,
	profilePicture,
	role,
	coinsLabel,
	DetailsText,
	defaultOpen = false,
	scrollable,
	children,
}: EmployeeDetailsCardProps) => {

	const [isOpen, setIsOpen] = useState(defaultOpen);

	const handleOpenChange = useCallback((open: boolean) => {
		setIsOpen(open);
	}, []);

	return (
		<ConfettiArmedContext.Provider value={isOpen}>
			<EmployeeDetailsCardContent>
				<EmployeeDetailsCardWrapper>
					<EmployeeDetailsWrapper>
						<ImageWrapper>
							<Image
								src={profilePicture}
								alt={`${name}'s profile picture`}
								aspectRatio="1/1"
								sizes="(max-width: 768px) 100vw, 50vw"
							/>
						</ImageWrapper>

						<DetailsWrapper>
							<NameLabel>{name}</NameLabel>
							<RoleLabel>{role}</RoleLabel>
						</DetailsWrapper>
					</EmployeeDetailsWrapper>

					{coinsLabel && (
						<CoinsLabel
							amount={coinsLabel.amount}
							valueLabel={coinsLabel.valueLabel}
							valueLabelPlural={coinsLabel.valueLabelPlural}
						/>
					)}
				</EmployeeDetailsCardWrapper>
			</EmployeeDetailsCardContent>

			<EmployeeDetailsCardAccordion
				title={DetailsText || ''}
				defaultOpen={defaultOpen}
				scrollable={scrollable}
				size="small"
				onToggle={handleOpenChange}
			>
				{children}
			</EmployeeDetailsCardAccordion>
		</ConfettiArmedContext.Provider>
	);
};
